import { FACILITY_INFO, LocationVarKey } from "@swivl-mono/types";

import { SearchableLabel } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";
import { TOPIC_VARS_BY_ID } from "../../../Views/Properties/CortexV3/Topics";
import { SCOPE_NOUN } from "../../../Views/Properties/CortexV3/Topics/FeaturesAmenities/FacilityInfo.Topic";
import { CortexTopicWorksheet } from "../Components/CortexTopicWorksheet";

export const PAGE_KEYS: LocationVarKey[] = TOPIC_VARS_BY_ID["facility-info"] ?? [];

export const SEARCH_LABELS: SearchableLabel[] = FACILITY_INFO.map((f) => ({ title: f.label, snippet: f.description }));

export default function FacilityInfoPage(): React.ReactElement {
  const page = usePropertiesGetLocationIds();
  const noun = SCOPE_NOUN[page.type];
  return (
    <CortexTopicWorksheet
      topicId="facility-info"
      heading={`${noun} Info`}
      description={`Basic ${noun.toLowerCase()} identity, contact, and hours data.`}
      sectionEditing
    />
  );
}
